import factory from './icon';
import Svg from './glyphs/back.svg';

export default factory(Svg);
